import React, { useCallback, useEffect, useState } from 'react'
import { reqGet, TOneItemCallback } from 'HttpRequests'
import PasswordInput from 'components/inputs/PasswordInput'
import EmptyLink from 'components/EmptyLink'
import LoadingBlueButton from 'components/inputs/LoadingBlueButton'
import { Form } from 'react-bootstrap'
import NameInput from 'components/inputs/NameInput'
import LoginPhoneInputWrap from './LoginPhoneInputWrap'
import EmailInput from 'components/inputs/EmailInput'
import CaptchaInput from 'components/inputs/CaptchaInput'

interface IRegistrationFormProps {
  isLoading: boolean
  loginPhone: string
  onChangeLoginPhone: TOneItemCallback<string>
  firstPassword: string
  secondPassword: string
  onChangeFirstPassword: TOneItemCallback<string>
  onChangeSecondPassword: TOneItemCallback<string>
  onRegister: (
    name: string,
    login: string,
    email: string,
    password: string,
    secondPassword: string,
    isRemember: boolean,
    captcha: string,
    captchaHash: string,
  ) => void
  onGoToLogin: VoidFunction
  onSetMessage: TOneItemCallback<string>
}

const RegistrationForm: React.FC<IRegistrationFormProps> = ({
  isLoading,
  loginPhone,
  onChangeLoginPhone,
  firstPassword,
  secondPassword,
  onRegister,
  onChangeFirstPassword,
  onChangeSecondPassword,
  onGoToLogin,
  onSetMessage,
}) => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [firstPasswordError, setFirstPasswordError] = useState<string>('')
  const [secondPasswordError, setSecondPasswordError] = useState<string>('')
  const [isFirstValid, setIsFirstValid] = useState(true)
  const [isSecondValid, setIsSecondValid] = useState(true)
  const [isRemember, setIsRemember] = useState(true)
  const [captcha, setCaptcha] = useState('')
  const [captchaImg, setCaptchaImg] = useState('')
  const [captchaHash, setCaptchaHash] = useState('')

  const handleChangeFirstPassword = useCallback(
    (value, isValid) => {
      setIsFirstValid(isValid)
      onChangeFirstPassword(value)
    },
    [onChangeFirstPassword]
  )

  const handleSecondChangePassword = useCallback(
    (value, isValid) => {
      setIsSecondValid(isValid)
      onChangeSecondPassword(value)
    },
    [onChangeSecondPassword]
  )

  useEffect(() => {
    if (!firstPassword) setFirstPasswordError('Введите пароль')
    else setFirstPasswordError('')

    if (!secondPassword) setSecondPasswordError('Повторите пароль')

    if (firstPassword.length > 0) {
      if (firstPassword !== secondPassword) {
        setSecondPasswordError('Пароли должны совпадать')
      } else {
        setSecondPasswordError('')
      }
    }
  }, [firstPassword, secondPassword])

  useEffect(() => {
    reqGet("/api/captcha/", (resp) => {
      setCaptchaImg(resp.img)
      setCaptchaHash(resp.hash)
    })
  }, [])


  const handleCheckRemember = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsRemember(event.target.checked)
  }

  const handleRegisterClick = useCallback(() => {
    if (
      !name ||
      name.length < 4 ||
      loginPhone.length === 0 ||
      !isFirstValid ||
      !isSecondValid ||
      firstPassword.length === 0 ||
      secondPassword.length === 0 ||
      firstPassword !== secondPassword ||
      !captcha ||
      captcha.length < 6
    ) {
      onSetMessage('Заполните поля')
    } else {
      onRegister(name, loginPhone, email, firstPassword, secondPassword, isRemember, captcha, captchaHash)
      reqGet("/api/captcha/", (resp) => {
        setCaptchaImg(resp.img)
        setCaptchaHash(resp.hash)
        setCaptcha('')
      })
    }
  }, [
    name,
    loginPhone,
    email,
    firstPassword,
    secondPassword,
    isFirstValid,
    isSecondValid,
    isRemember,
    captcha,
    captchaHash,
    onSetMessage,
    onRegister,
  ])

  return (
    <div>
      <p>Пожалуйста, авторизуйтесь</p>
      <NameInput defaultValue={name} onChange={setName} />
      <div className='m-2' />
      <LoginPhoneInputWrap
        isRequired
        value={loginPhone}
        onlyPhone
        onChange={() => {}}
        onEntered={onChangeLoginPhone}
        style={{ width: '100%' }}
      />

      <div className='m-2' />
      <EmailInput
        placeholder='Почта (не обязательно)'
        defaultValue={email}
        onChange={setEmail}
        style={{ width: '100%' }}
      />

      <div className='m-2' />
      <PasswordInput
        required
        value={firstPassword}
        errorMessage={firstPasswordError}
        placeholder='пароль'
        onChange={handleChangeFirstPassword}
        maxLength={20}
        style={{ width: '100%' }}
      />

      <div className='m-2'></div>
      <PasswordInput
        required
        value={secondPassword}
        errorMessage={secondPasswordError}
        placeholder='подтвердите пароль'
        onChange={handleSecondChangePassword}
        onEntered={handleRegisterClick}
        maxLength={20}
        minLength={8}
        style={{ width: '100%' }}
      />
      <div className='m-2'></div>

      <Form.Check
        checked={isRemember}
        type='checkbox'
        label='Запомнить меня'
        onChange={handleCheckRemember}
      />
      <div className='m-2'></div>

      <input type="hidden" value={captchaHash} />
      <img src={"data:image/jpeg;base64, " + captchaImg} alt="Captcha" />
      <CaptchaInput value={captcha} onChange={setCaptcha} />
      <div className='m-2'></div>

      <div style={{ marginBottom: '1rem' }}>
        <LoadingBlueButton
          onClick={handleRegisterClick}
          isLoading={isLoading}
          style={{ width: '100%' }}
        >
          Зарегиcтрироваться
        </LoadingBlueButton>
      </div>

      <EmptyLink onClick={onGoToLogin}>Есть учетная запись? Войти!</EmptyLink>
    </div>
  )
}
export default RegistrationForm
